var map = {
	"../shared-modules/library/library.module": [
		"../../../../../src/app/layout/shared-modules/library/library.module.ts",
		"common",
		"library.module"
	],
	"./auth-modules/login/login.module": [
		"../../../../../src/app/auth-modules/login/login.module.ts",
		"login.module"
	],
	"./auth-modules/reset-password/reset-password.module": [
		"../../../../../src/app/auth-modules/reset-password/reset-password.module.ts",
		"reset-password.module"
	],
	"./course/course.module": [
		"../../../../../src/app/layout/student/course/course.module.ts",
		"common"
	],
	"./elective-and-field-seminar/elective-and-field-seminar.module": [
		"../../../../../src/app/layout/student/elective-and-field-seminar/elective-and-field-seminar.module.ts",
		"common"
	],
	"./exchange/exchange.module": [
		"../../../../../src/app/layout/exchange/exchange.module.ts",
		"common",
		"exchange.module"
	],
	"./external-modules/evaluation/evaluation.module": [
		"../../../../../src/app/external-modules/evaluation/evaluation.module.ts",
		"common",
		"evaluation.module"
	],
	"./guest-course/course.module": [
		"../../../../../src/app/layout/exchange/guest-course/course.module.ts",
		"common",
		"course.module"
	],
	"./inbox/inbox.module": [
		"../../../../../src/app/layout/student/inbox/inbox.module.ts",
		"inbox.module"
	],
	"./layout/layout.module": [
		"../../../../../src/app/layout/layout.module.ts",
		"layout.module"
	],
	"./photo-gallery/photo-gallery.module": [
		"../../../../../src/app/layout/student/photo-gallery/photo-gallery.module.ts",
		"common",
		"photo-gallery.module"
	],
	"./search/search.module": [
		"../../../../../src/app/layout/search/search.module.ts",
		"common",
		"search.module"
	],
	"./student/student.module": [
		"../../../../../src/app/layout/student/student.module.ts",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// G:/UTL/Student/Student-ANG/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main